import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme } from "shared/lib/styles";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";
import IconLogoFlag from "scmp-app/components/header/icon-logo-flag.svg";

export const Container = styled(ResponsiveContainer)``;

export const StyledLogoLink = styled(BaseLink)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

export const StyledScmpLogoFlag = styled(IconLogoFlag)`
  inline-size: 28.43px;
  block-size: 21.54px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 39px;
    block-size: 30px;
  }
`;
